import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from './Button';

const StyledButton = styled(Button)`
  &:hover {
    border-color: ${props =>
      props.selected
        ? props.theme.primary.normal
        : props.theme.primary.primary200};
  }
  ${props =>
    props.selected &&
    `& svg {
    fill: ${props.theme.primary.normal}
  }`}
`;

const SelectButton = ({ children, selected, ...props }) => (
  <StyledButton
    type="button"
    border
    rounded
    primary={selected}
    fontSize="14px"
    borderColor={theme =>
      selected ? theme.primary.normal : theme.border.border600
    }
    backgroundColor={theme => (selected ? theme.primary.primary100 : 'white')}
    display="flex"
    alignItems="center"
    justifyContent="center"
    margin="4px"
    width="auto"
    height="40px"
    selected={selected}
    fontWeight="600"
    {...props}
  >
    {children}
  </StyledButton>
);

SelectButton.propTypes = {
  children: PropTypes.node,
  selected: PropTypes.bool,
};

SelectButton.defaultProps = {
  children: null,
  selected: false,
};

export default SelectButton;
